const translations = {
  searchOnMap: 'Buscar no mapa',
  useCompleteSearch: 'Usar busca completa',
  selectUsers: 'Seleção de usuários',
  'filters.creation': 'Criação'
}

export default translations
